var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11222_8549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dental_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60647 2.436C4.09513 2.146 4.6738 2 5.33313 2C5.9838 2 6.53847 2.32867 6.92113 2.55533C7.24513 2.74867 7.6078 3 7.9998 3C8.3918 3 8.75447 2.748 9.07847 2.55533C9.4618 2.32933 10.0165 2 10.6665 2C11.3265 2 11.9051 2.146 12.3931 2.436C12.8811 2.726 13.2418 3.13867 13.4971 3.61467C13.9971 4.54533 14.1105 5.74267 14.0418 6.908C13.9718 8.09133 13.7085 9.32867 13.3745 10.4047C13.0425 11.472 12.6251 12.43 12.2211 13.0367C11.7571 13.732 11.1125 14.078 10.4291 13.982C9.8018 13.894 9.31447 13.4533 9.07047 12.9647C8.8098 12.4433 8.68914 11.8613 8.46047 11.326C8.34714 11.062 8.23847 10.8753 8.13714 10.7627C8.03047 10.6453 7.9658 10.6487 7.86314 10.7627C7.76114 10.8753 7.65247 11.062 7.53913 11.326C7.31047 11.8613 7.19047 12.4433 6.9298 12.9647C6.68513 13.4533 6.1978 13.894 5.57114 13.982C4.88714 14.078 4.24247 13.732 3.77847 13.0367C3.37447 12.43 2.95713 11.472 2.62513 10.4047C2.29113 9.32867 2.0278 8.09133 1.95847 6.90867C1.88913 5.742 2.00247 4.54533 2.50247 3.61467C2.7578 3.13867 3.11847 2.726 3.60647 2.436Z",
    fill: "#F0F7FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11222_8549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntreatment);
export default __webpack_public_path__ + "static/media/intreatment.1e2fe8df0dfc8e205420942fb0046479.svg";
export { ForwardRef as ReactComponent };